export default function LanguageTab() {
    return (
        <h2>Language</h2>
    );
}